/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RegisterDevice200ResponseDevice
 */
export interface RegisterDevice200ResponseDevice {
    /**
     * 
     * @type {string}
     * @memberof RegisterDevice200ResponseDevice
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDevice200ResponseDevice
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof RegisterDevice200ResponseDevice
     */
    deviceName?: string;
    /**
     * 
     * @type {boolean}
     * @memberof RegisterDevice200ResponseDevice
     */
    isActive?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RegisterDevice200ResponseDevice
     */
    createdAt?: string;
}

/**
 * Check if a given object implements the RegisterDevice200ResponseDevice interface.
 */
export function instanceOfRegisterDevice200ResponseDevice(value: object): value is RegisterDevice200ResponseDevice {
    return true;
}

export function RegisterDevice200ResponseDeviceFromJSON(json: any): RegisterDevice200ResponseDevice {
    return RegisterDevice200ResponseDeviceFromJSONTyped(json, false);
}

export function RegisterDevice200ResponseDeviceFromJSONTyped(json: any, ignoreDiscriminator: boolean): RegisterDevice200ResponseDevice {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'deviceType': json['deviceType'] == null ? undefined : json['deviceType'],
        'deviceName': json['deviceName'] == null ? undefined : json['deviceName'],
        'isActive': json['isActive'] == null ? undefined : json['isActive'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
    };
}

export function RegisterDevice200ResponseDeviceToJSON(json: any): RegisterDevice200ResponseDevice {
    return RegisterDevice200ResponseDeviceToJSONTyped(json, false);
}

export function RegisterDevice200ResponseDeviceToJSONTyped(value?: RegisterDevice200ResponseDevice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'deviceType': value['deviceType'],
        'deviceName': value['deviceName'],
        'isActive': value['isActive'],
        'createdAt': value['createdAt'],
    };
}

